if (!customElements.get('product-size-chart')) {
  customElements.define(
    'product-size-chart',
    class ProductSizeChart extends HTMLElement {
      constructor() {
        super();
        this.onKeyUp = this.onKeyUp.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.openButton = this.querySelector('[data-size-chart-open]');
        this.drawer = this.querySelector('[data-size-chart-drawer]');
        this.panel = this.querySelector('[data-size-chart-panel]');
        this.closeButtons = this.querySelectorAll('[data-size-chart-close]');
        this.unitButtons = this.querySelectorAll('[data-size-chart-unit]');
        this.unitPanels = this.querySelectorAll('[data-size-chart-unit-panel]');

        if (!this.openButton || !this.drawer || !this.panel) return;

        this.parentModal = this.closest('quick-add-modal');
        this.inheritColorScheme();
        document.body.appendChild(this.drawer);

        this.initialized = true;
        this.openButton.addEventListener('click', this.open.bind(this));
        this.closeButtons.forEach((button) => button.addEventListener('click', this.close.bind(this)));
        this.unitButtons.forEach((button) => {
          button.addEventListener('click', () => this.setUnit(button.dataset.sizeChartUnit));
        });
      }

      disconnectedCallback() {
        document.removeEventListener('keyup', this.onKeyUp, true);

        if (this.drawer && this.drawer.hasAttribute('open')) {
          this.close();
        }

        if (this.drawer && this.drawer.parentElement === document.body) {
          this.drawer.remove();
        }
      }

      inheritColorScheme() {
        const colorSchemeElement = this.closest('[class*="color-"]');

        if (!colorSchemeElement) return;

        colorSchemeElement.classList.forEach((className) => {
          if (className === 'gradient' || className.startsWith('color-')) {
            this.drawer.classList.add(className);
          }
        });
      }

      open(event) {
        event.preventDefault();

        this.drawer.setAttribute('open', '');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.drawer.setAttribute('aria-modal', 'true');
        this.openButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keyup', this.onKeyUp, true);

        const focusDrawer = () => {
          if (this.drawer.hasAttribute('open') && typeof trapFocus === 'function') {
            trapFocus(this.drawer, this.panel.querySelector('[data-size-chart-close]') || this.drawer);
          }
        };
        requestAnimationFrame(focusDrawer);
        this.panel.addEventListener('transitionend', focusDrawer, { once: true });
      }

      close(event) {
        if (event) event.preventDefault();

        this.drawer.removeAttribute('open');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.drawer.setAttribute('aria-modal', 'false');
        this.openButton.setAttribute('aria-expanded', 'false');
        const parentIsOpen = this.parentModal?.hasAttribute('open');
        document.body.classList.toggle('overflow-hidden', Boolean(parentIsOpen));
        document.removeEventListener('keyup', this.onKeyUp, true);

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.openButton);
        }
        if (parentIsOpen && typeof trapFocus === 'function') {
          trapFocus(this.parentModal, this.openButton);
        }
      }

      onKeyUp(event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          event.stopPropagation();
          this.close(event);
        }
      }

      setUnit(unit) {
        if (!unit) return;

        this.unitButtons.forEach((button) => {
          const isActive = button.dataset.sizeChartUnit === unit;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.unitPanels.forEach((panel) => {
          panel.hidden = panel.dataset.sizeChartUnitPanel !== unit;
        });
      }
    }
  );
}
